export class BvaData {
  notes?: string;
  providers?: any;

  constructor(obj?) {
    this.notes = obj.notes || '';
    this.providers = obj.providers || {};
  }
}
